import React, { Component } from 'react';
import registerService from 'services/RegisterService';
import { RegisterResultType } from 'services/EnumConstants'
import ComponentContainer from 'containers/ComponentContainer';
import RegisterWeb from './RegisterWeb';
import RegisterMobile from './RegisterMobile';
import TermsOfServiceModal from './TermsOfServiceModal';
import AccountAlreadyExistsModal from './AccountAlreadyExistsModal';
import 'extensions/urlSearchParamsExtensions';

export default class RegisterWrapper extends Component {
    state = {
        loading: true,
        email: '',
        newPassword: '',
        confirmNewPassword: '',
        firstName: '',
        lastName: '',
        emailErrorId: undefined,
        registerErrorId: undefined,
        emailFromSocial: false,
        firstFromSocial: false,
        lastFromSocial: false,
        environment: '',
        showTermsOfService: false,
        agreeToTerms: false,
        emailCommunication: false,
        showAccountAlreadyExists: false,
        otherApplications: []
    }

    render() {
        const { registerConfig, setValues } = this.props;
        return (
            <ComponentContainer loading={this.state.loading}>

                {(props) => {
                    this.parentProps = props;

                    return (
                        <div>
                        {registerConfig.formType === 'web' ?
                            <RegisterWeb
                                data={this.state}
                                onSubmit={this.handleSubmit}
                                onEmailChanged={this.handleEmailChanged}
                                onEmailBlurred={this.handleEmailBlurred}
                                onHandleClose={this.handleCloseModal}
                                onHandleGoogle={this.handleGoogle}
                                onHandleFacebook={this.handleFacebook}
                                onHandleMicrosoft={this.handleMicrosoft}
                                onHandleApple={this.handleApple}
                                registerConfig={registerConfig || { sso: [] }}
                                intl={this.parentProps.intl}
                                onShowTerms={this.handleShowTerms}
                                />
                                :
                                <RegisterMobile
                                    data={this.state}
                                    onSubmit={this.handleSubmit}
                                    onEmailChanged={this.handleEmailChanged}
                                    onEmailBlurred={this.handleEmailBlurred}
                                    onHandleClose={this.handleCloseModal}
                                    onHandleGoogle={this.handleGoogle}
                                    onHandleFacebook={this.handleFacebook}
                                    onHandleMicrosoft={this.handleMicrosoft}
                                    onHandleApple={this.handleApple}
                                    registerConfig={registerConfig || { sso: [] }}
                                    intl={this.parentProps.intl}
                                    onShowTerms={this.handleShowTerms}
                                />
                            }
                        <TermsOfServiceModal
                            values={this.state}
                            open={this.state.showTermsOfService}
                            terms={this.parentProps.intl.formatMessage({ id: registerConfig.termsOfUseText })}
                            onHandleAgree={this.handleTermsAgreement}
                            onHandleDisagree={this.handleTermsDisagreement}
                            onHandleClose={this.handleCloseTerms}
                            setValues={setValues}
                            readOnly={false} />

                        <AccountAlreadyExistsModal 
                            open={this.state.showAccountAlreadyExists}
                            applications={this.state.otherApplications}
                            values={this.state}
                            setValues={setValues}
                            onClose={this.handleCloseAlreadyExists} />
                        </div>
                    );
                }}

            </ComponentContainer>
        );
    }

    handleGoogle = (values) => {
        this.goToAuth('Google', values);
    }

    handleFacebook = (values) => {
        this.goToAuth('Facebook', values);
    }

    handleMicrosoft = (values) => {
        this.goToAuth('Microsoft', values);
    }

    handleApple = (values) => {
        this.goToAuth('Apple', values);
    }

    goToAuth = (provider) => {
        var url = '/External/ChallengeSocial?provider=' + provider + '&saveUrl=' + this.state.returnUrl + '&returnUrl=' + this.props.registerConfig.authUrl;
        window.location.href = url;
    }

    handleTermsAgreement = (values) => {
        this.setState({
            ...values,
            showTermsOfService: false,
            agreeToTerms: true
        });
    };

    handleTermsDisagreement = (values) => {
        this.setState({
            ...values,
            showTermsOfService: false,
            agreeToTerms: false
        });
    };

    handleCloseTerms = (values) => {
        this.setState({
            ...values,
            showTermsOfService: false
        });
    };

    handleShowTerms = (values) => {
        this.setState({
            ...values,
            showTermsOfService: true
        });
    };

    handleCloseModal = (values) => {
        this.setState({
            ...values,
            showTermsOfService: false
        });
    };

    handleCloseAlreadyExists = (values) => {
        this.setState({
            ...values,
            showAccountAlreadyExists: false
        });

        // send user to the login screen to make sure this is who they say they are
        window.location.href = '/app/login?ReturnUrl=' + this.state.returnUrl;
    }

    handleSubmit = (values, props) => {
        values.email = values.email.trim();
        const { setSubmitting, setValues } = props;

        setSubmitting(true);

        if (values.role === '') {
            values.role = 0;
        }

        // reset all the error states
        setValues({
            ...values,
            registerErrorId: undefined
        }, false);
        registerService
            .register(values, this.state.returnUrl, this.state.provider)
            .then((result) => this.registerCompleted(result, values, props))
            .finally(() => setSubmitting(false));
    };

    handleEmailChanged = (email, props, values) => {
        const { errors } = props;

        if (this.validateIntent) {
            clearTimeout(this.validateIntent);
        }

        if (email && !errors.email) {
            this.validateIntent = setTimeout(() => {
                this.validateEmail(email, props, values);
            }, 2000);
        }
    };

    handleEmailBlurred = (email, props, values) => {
        const { errors } = props;

        if (this.validateIntent) {
            clearTimeout(this.validateIntent);
        }

        if (email && !errors.email) {
            this.validateEmail(email, props, values);
        }
    }

    validateEmail = (email, props, values) => {
        let emailError = undefined;

        const { setFieldValue, setFieldError } = props;
        setFieldValue('emailErrorId', emailError);
        values.emailErrorId = emailError;
        registerService.isValidEmailNewUser(email.trim(), this.state.returnUrl)
            .then((response) => {

                if (response.blacklisted) {
                    emailError = 'register.emailAddressDomainBlacklisted';
                } else if (response.alreadyAUser) {
                    emailError = 'register.emailAddressAlreadyExists';
                } else if (response.userInOtherApps) {
                    this.setState({ showAccountAlreadyExists: true, otherApplications: response.otherApplications });
                }

                if (emailError) {
                    setFieldValue('emailErrorId', emailError);
                    setFieldError('email', true);
                }

                let emailFromSocial = false;
                if (response.provider) {
                    emailFromSocial = true;
                }

                this.setState({ emailFromSocial, email, emailErrorId: emailError });
                values.email = email;
            });

        // to keep fields already entered...
        this.setState({ ...values });
    }

    validateExternalEmail = (email, returnUrl) => {
        let emailErrorId = undefined;

        registerService.isValidEmailNewUser(email, returnUrl)
            .then((response) => {

                if (response.blacklisted) {
                    emailErrorId = 'register.emailAddressDomainBlacklisted';
                } else if (response.alreadyExists) {
                    emailErrorId = 'register.emailAddressAlreadyExists';
                }

                let emailFromSocial = false;
                if (response.provider) {
                    emailFromSocial = true;
                }

                let firstFromSocial = false;
                if (response.firstName) {
                    firstFromSocial = true;
                }

                let lastFromSocial = false;
                if (response.lastName) {
                    lastFromSocial = true;
                }
                this.setState({ emailFromSocial, firstFromSocial, lastFromSocial, email, emailErrorId, firstName: response.firstName, lastName: response.lastName });
            });
    }

    registerCompleted = (result, values, props) => {
        const { setValues } = props;
        const resultTypeCode = result.result;
        let registerError;

        switch (resultTypeCode) {
            case RegisterResultType.EmailAlreadyExists:
                registerError = 'register.emailAddressAlreadyExists';
                break;
            case RegisterResultType.InvalidEmailProvider:
                registerError = 'register.emailAddressDomainBlacklisted';
                break;
            case RegisterResultType.ErrorAddingUser:
                registerError = 'register.lockedOut';
                break;
            case RegisterResultType.SocialUserNotFound:
                registerError = 'register.socialUserNotFound';
                break;
            case RegisterResultType.InvalidProvider:
                registerError = 'register.invalidProvider';
                break;
            default:
                registerError = '';
                if (result.validatedRedirectUri) {
                    window.location.replace(decodeURIComponent(result.validatedRedirectUri));
                } else {
                    if (this.state.returnUrl) {
                        window.location.href = '/app/registersuccess?ReturnUrl=' + this.state.returnUrl;
                    } else {
                        window.location.href = '/app/registersuccess';
                    }
                }
                break;
        }

        setValues({ ...values });
        this.setState({ ...values, registerErrorId: registerError });
    };

    componentDidMount() {
        var queryString = this.props.search;
        if (queryString) {
            this.initializeInput(queryString);
        }

        if (this.props.registerConfig) {
            this.setState({ sso: this.props.registerConfig.sso });
        }

        this.setState({ loading: false });
    }

    initializeInput(queryString) {
        let searchParams = new URLSearchParams(encodeURI(queryString));
        let returnUrl = searchParams.getIgnoreCase('ReturnUrl');

        let email = searchParams.getIgnoreCase('email');
        if (email) {
            email = decodeURIComponent(email);
            this.validateExternalEmail(email, returnUrl);
        } else {
            email = '';
        }

        let firstName = searchParams.getIgnoreCase('firstName');
        let lastName = searchParams.getIgnoreCase('lastName');

        this.setState({
            email,
            firstName,
            lastName,
            returnUrl: returnUrl
        });
    }
}
